module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }, [_c('span', {
    staticClass: "dn-chk-btn__faux"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1), _vm._v(" "), (_vm.$slots.default) ? _c('span', {
    staticClass: "dn-chk-btn__label"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3fea80","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/buttons/ChkBtn.vue
// module id = 257
// module chunks = 1